import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';

import { useToast } from 'Store/toast';
import Cookies from 'universal-cookie';
import { useUserInfo } from 'Store/userInfo';
import { useAppSystem } from 'Store/app';

const useLogout = () => {
  const navigate = useNavigate();
  const { onOpenToast } = useToast();
  const { onResetUserInfo } = useUserInfo();
  const { onResetAppSystem } = useAppSystem();

  return useMutation({
    mutationFn: async ({ isReload }) => {
      const cookies = new Cookies();

      cookies.remove('token', { path: '/' });
      cookies.remove('username', { path: '/' });
      cookies.remove('liveSchedule', { path: '/' });
      cookies.remove('roleId', { path: '/' });
      cookies.remove('roleName', { path: '/' });
      cookies.remove('isLive', { path: '/' });
      cookies.remove('userId', { path: '/' });
      cookies.remove('userIdentity', { path: '/' });
      cookies.remove('appVersion', { path: '/' });
      cookies.remove('organization', { path: '/' });

      localStorage.removeItem('accessPermission');
      localStorage.removeItem('faceRecognitionModel');
      localStorage.removeItem('captchaScheduledTime');

      onResetUserInfo();

      onResetAppSystem();

      return { isReload };
    },
    onSuccess: ({ isReload }) => {
      onOpenToast({
        status: 'success',
        title: 'Success',
        description: `Berhasil melakukan logout!`,
        duration: 5,
        alwaysShow: false,
      });

      navigate('/login');

      if (isReload) window.location.reload();
    },
    onError: (error) => {
      console.log(error);
      onOpenToast({
        status: 'error',
        title: 'Error',
        description: `Gagal melakukan logout!`,
        duration: 3,
        alwaysShow: false,
      });
    },
  });
};

export default useLogout;
